import { z } from 'zod';
export const meetingBodyRoleAssignmentCreateSchema = z.object({
    userId: z.number({ message: 'User ID is required' }),
    meetingBodyRoleId: z.number().nullable(),
    meetingBodyId: z.number({ message: 'Meeting body ID is required' }),
});
export const meetingBodyRoleAssignmentUpdateSchema = z.object({
    meetingBodyRoleId: z.number({ message: 'Meeting body role ID is required' }),
});
